// 接口请求基本配置
// 日志插件
// import * as MITO from '@zyf2e/monitor-web'
// import { cacheAdapterEnhancer } from 'axios-extensions'
// import LRUCache from 'lru-cache'
import moment from 'moment' // 时间转换
import apiConfig from '~/assets/js/api/index'
import { fxlog } from '~/utils/utils'

const tokenURL = process.env.NODE_ENV == 'production' ? 'https://wikidatacenter.interface003.com:32377' : 'https://wikidatacenter.interface003.com:32377'

export default ({ $axios, store, $cookies, error, app, $winstonLog }, inject) => {
  // ---------- 处理请求拦截的准备工作（开始） ----------
  let isRefreshing = false // 是否正在刷新
  const requests = [] // 存储请求的数组
  // 挂起请求
  function subscribeTokenRefresh (cb) {
    requests.push(cb)
  }
  // 执行挂起的请求（数组中的请求得到新的token之后自执行，用新的token去请求数据）
  function onRrefreshed (token) {
    requests.map(cb => cb(token))
  }
  // ---------- 处理请求拦截的准备工作（结束） ----------

  // 接口报错，容错处理
  const errorHandler = (err = {}) => {
    console.log('err111: ', err, 11, err.request.path, 22, err.message, 33, err.status, 44, new Date())
    // if (process.env.NODE_ENV == 'development') return
    // err.config.headers.metadata.endtime = new Date().getTime()
    const timer = new Date().getTime() - err.config.headers.metadata.starttime
    if ($winstonLog) { // 服务端接口报错，存入本地
      const mttime = moment()
      const msg = `${mttime.format('YYYY-MM-DD HH:mm:ss.sss')} ERROR [DATA-API-WEB]:{"Function":"asyncData中的axios异常","Url":"${err.config.url}","HttpType":"${err.config.method}","HttpState":${err.response.status},"Time":${timer},"Parameter":${JSON.stringify(err.config.params)},"Message":"${err.message}","WikiRequestId":"${mttime.format('YYYYMMDDHHmmssSSS')}${(Math.random() * 899999).toString().replace('.', '')}"}`
      $winstonLog.error(msg)
    } else {
      try {
        const mttime = moment()
        const msg = `{"Function":"JS中的axios异常","Url":"${err.config.url}","params":"${err.config.params}","CountryCode":"${err.config.headers.CountryCode}","LanguageCode":"${err.config.headers.LanguageCode}","BasicData":"${err.config.headers.BasicData}","HttpType":"${err.config.method}","HttpState":${err.response.status},"Time":${timer},"Parameter":${JSON.stringify(err.config.params)},"Message":"${err.message}","WikiRequestId":"${mttime.format('YYYYMMDDHHmmssSSS')}${(Math.random() * 899999).toString().replace('.', '')}"}`
        fxlog(msg, err.config.url)
      } catch (err) { }
    }
    return Promise.reject(error)
  }
  // 创建axios请求
  // const defaultAdapter = $axios.defaults.adapter
  // const cacheCfg = new LRUCache({ maxAge: 1000 * 6000, max: 2000 })
  // $axios.defaults.adapter = cacheAdapterEnhancer(defaultAdapter, { enabledByDefault: false, cacheFlag: 'useCache', defaultCache: cacheCfg })
  const request = $axios.create({ baseURL: '', timeout: 20000 })

  // 请求拦截
  request.interceptors.request.use(async (config) => {
    // 服务端请求
    // config.metadata.starttime = new Date().getTime()
    // console.log(config.headers, 886)
    // const bfp = $cookies.get('wiki-bfp') ? $cookies.get('wiki-bfp') : '822ca7b3261a0b2ec10c8cdabfb5a0ea'
    // const base = (store.state.isWiki == '1' || store.state.isWiki == '3') ? `999,0,2,999,0,${bfp},0` : `999,0,1,225,1,${bfp},0`
    // const base = store.state.isWiki == '1' ? `999,0,2,999,0,${bfp},0` : ((store.state.isWiki == '2' || store.state.isWiki == '4') ? `999,0,1,225,1,${bfp},0` : ((store.state.myCountry == 'cn' ? `999,0,1,225,1,${bfp},0` : `999,0,2,999,0,${bfp},0`)))
    const bfp = $cookies.get('wiki-bfp') ? $cookies.get('wiki-bfp') : '822ca7b3261a0b2ec10c8cdabfb5a0ea'
    // const base = (store.state.isWiki == '1' || store.state.isWiki == '3') ? `999,0,2,999,0,${bfp},0` : `999,0,1,225,1,${bfp},0`
    // const base = store.state.isWiki == '1' ? `999,0,2,999,0,${bfp},0` : ((store.state.isWiki == '2' || store.state.isWiki == '4') ? `999,0,1,225,1,${bfp},0` : ((store.state.myCountry == 'cn' ? `999,0,1,225,1,${bfp},0` : `999,0,2,999,0,${bfp},0`)))
    let base = `999,0,2,999,0,${bfp},0`
    if (store.state.isWiki == '1') {
      base = `999,0,2,999,0,${bfp},0`
    } else if (store.state.myCountry == 'cn') {
      base = `999,0,1,999,1,${bfp},1`
    } else {
      base = `999,0,2,999,0,${bfp},0`
    }
    Object.assign(config.headers, {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      CountryCode: store.state.CountryCode,
      'x-forword-for': store.state.userIp,
      LanguageCode: store.state.LanguageCode,
      BasicData: base,
      ENVIRONMENT: store.state.nodeEnv,
      metadata: {
        starttime: new Date().getTime()
      }
    })
    // config.headers = {
    //   'Content-Type': 'application/json',
    //   'X-Requested-With': 'XMLHttpRequest',
    //   CountryCode: store.state.CountryCode,
    //   'x-forword-for': store.state.userIp,
    //   LanguageCode: store.state.LanguageCode,
    //   BasicData: store.state.isWiki ? `999,0,2,999,0,${bfp},0` : `999,0,1,225,1,${bfp},0`,
    //   metadata: {
    //     starttime: new Date().getTime()
    //   }
    // }
    const [now, cookieTime] = [Date.parse(new Date()), $cookies.get('expiresIn')] // 获取当前时间戳和token有效时长
    if (process.server) return config
    // 客户端请求
    const au = `fx${store.state.userIp.split('.').join('')}`
    const token = $cookies.get(au)
    // console.log(token, now < cookieTime, 444)
    if (token && now < cookieTime) { // 存在token且尚未失效时
      config.headers.Authorization = `Bearer ${token}`
      return config
    } else { // 不存在token时
      if (!isRefreshing) {
        isRefreshing = true // 正在刷新中
        const authorizeData = await $axios.post(`${tokenURL}/oauth2/authorize`, { // 1. 获取授权码
          response_type: 'code',
          scope: 'email address',
          client_id: 'YWdncmVnYXRpb24tYXV0aGVudGljYXRpb24taWQ=',
          provision_key: 'wiki-aggregation-layer-key',
          authenticated_userid: 'authenticated_tester'
        })
        // isRefreshing = true // 正在刷新中
        const tokenData = await $axios.post(`${tokenURL}/oauth2/token`, { // 2. 获取访问码
          grant_type: 'authorization_code',
          client_id: 'YWdncmVnYXRpb24tYXV0aGVudGljYXRpb24taWQ=',
          client_secret: 'YWdncmVnYXRpb24tYXV0aGVudGljYXRpb24tc2VjcmV0',
          code: authorizeData.data.redirect_uri.split('=')[1]
        })
        isRefreshing = false
        const { access_token: ntoken = '', expires_in: expiresIn = '' } = tokenData.data || {}
        // console.log(ntoken, 88812)
        const in1hour = expiresIn * 1000 + Date.parse(new Date()) // 有效时长
        $cookies.set(au, ntoken, { maxAge: 600, domain: store.state.cookieHost, path: '/' }) // 存储token
        $cookies.set('expiresIn', in1hour, { maxAge: 600, domain: store.state.cookieHost, path: '/' }) // 存储token有效时长
        config.headers.Authorization = `Bearer ${ntoken}`
        onRrefreshed(ntoken)
        config.headers.Authorization = `Bearer ${ntoken}`
        return config
      }
      const retry = new Promise((resolve) => {
        subscribeTokenRefresh((accessToken) => {
          config.headers.Authorization = `Bearer ${accessToken}`
          resolve(config)
        })
      })
      return retry
      // config.headers.Authorization = `Bearer ${ntoken}`
      // return config
    }
  }, errorHandler)

  // 响应拦截
  request.interceptors.response.use((res) => {
    // res.config.headers.metadata.endtime = new Date().getTime()
    const timer = new Date().getTime() - res.config.headers.metadata.starttime
    if (timer >= 1000) {
      const param = {
        url: res.config.url, // 请求地址
        method: res.config.method, // 请求方式
        statusCode: res.status, // 请求状态
        params: res.config.params, // 请求参数
        timer, // 请求时间
        level: 'warn', // 报错等级info-严重；warn-警告
        type: 'url', // url接口-asyncData-asyncData js报错
        message: '接口超时', // 报错内容
        CountryCode: res.config.headers.CountryCode, // header国家
        LanguageCode: res.config.headers.LanguageCode, // headers语言
        BasicData: res.config.headers.BasicData, // header---BasicData
        requestid: res.headers['wikidatacenter-request-id'] // 唯一标识id
      }
      console.log(param, 8887)
      if ($winstonLog) {
        const mttime = moment()
        const msg = `${mttime.format('YYYY-MM-DD HH:mm:ss.SSS')} WARN [DATA-API-WEB]:{"Function":"axios耗时","Url":"${res.config.url}","HttpType":"${res.config.method}","HttpState":${res.status},"Time":${timer},"Parameter":${JSON.stringify(res.config.params)},"Message":"接口慢","WikiRequestId":"${mttime.format('YYYYMMDDHHmmssSSS')}${(Math.random() * 899999).toString().replace('.', '')}"}`
        $winstonLog.info(msg)
      } else {
        try {
          const mttime = moment()
          const msg = `{"Function":"axios耗时2","Url":"${res.config.url}","HttpType":"${res.config.method}","HttpState":${res.status},"Time":${timer},"Parameter":${JSON.stringify(res.config.params)},"Message":"接口慢","WikiRequestId":"${mttime.format('YYYYMMDDHHmmssSSS')}${(Math.random() * 899999).toString().replace('.', '')}"}`
          fxlog(msg, res.config.url)
        } catch (err) { }
      }
    }
    const { succeed = true, ErrorCode = 200, Data = '', data = '' } = res.data

    if (ErrorCode != 200 || !succeed) return process.client ? (res.data.data || res.data) : null // 数据返回不正常，客户端请求的接口返回错误数据，服务端请求的接口进入错误页面
    else return (Data || data) ? Promise.resolve(Data || data) : res.data // 两者只要有一个字段存在数据，就返回数据
  }, errorHandler)

  // 模块接口注入
  const apiObj = {}
  if (apiConfig) {
    for (const i in apiConfig) {
      apiObj[i] = apiConfig[i](request)
    }
  }
  inject('api', apiObj)
}
